import {
  LOGIN_USER, LOGOUT_USER, LOGIN_USER_ERROR, SET_LANG,
  SELECT_WORKCENTER_REQUIRED, SWITCH_WORKCENTER_REQUESTED,
  TALLY_REQUIRED, TALLY_CANCELLED
} from '../constants/ActionTypes'

const resetState = {
  invalid: false,
  lang: false,
  pendingToken: false,
  workcenters: false,
  pendingTally: false,
  pendingTallyMode: false,
  pendingSwitchWorkcenterId: false,
  session: {
    token: false,
    username: false,
    workcenter_name: false
  }
}

function setSession(session){
  localStorage.setItem('ideaerp_production_token', session.token)
  localStorage.setItem('ideaerp_production_username', session.username)
  localStorage.setItem('ideaerp_workcenter_name', session.workcenter_name)
  localStorage.setItem('ideaerp_production_workcenters', JSON.stringify(session.workcenters || []))
}

function setLang(lang){
  localStorage.setItem('lang', lang)
}

function destroySession(){
  localStorage.removeItem('ideaerp_production_token')
  localStorage.removeItem('ideaerp_production_username')
  localStorage.removeItem('ideaerp_workcenter_name')
  localStorage.removeItem('ideaerp_production_workcenters')
}

function getSession(){
  return {
    session: {
      'token': localStorage.getItem('ideaerp_production_token') || false,
      'username': localStorage.getItem('ideaerp_production_username') || false,
      'workcenter_name': localStorage.getItem('ideaerp_workcenter_name') || false
    },
    workcenters: JSON.parse(localStorage.getItem('ideaerp_production_workcenters') || 'false') || false
  }
}

function getInitialState(){
  return {...getSession(),
    invalid: false,
    pendingToken: false,
    pendingTally: false,
    pendingTallyMode: false,
    pendingSwitchWorkcenterId: false
  }
}

export default function auth(state = getInitialState(), action) {
  switch (action.type) {
    case LOGIN_USER:
      setSession(action.payload)
      return { ...state,
        invalid: false,
        pendingToken: false,
        pendingTally: false,
        pendingTallyMode: false,
        pendingSwitchWorkcenterId: false,
        ...getSession()
      }
    case SELECT_WORKCENTER_REQUIRED:
      return { ...state,
        invalid: false,
        pendingToken: action.payload.pendingToken,
        workcenters: action.payload.workcenters
      }
    case SWITCH_WORKCENTER_REQUESTED:
      return { ...state,
        invalid: false,
        pendingToken: state.session.token
      }
    case TALLY_REQUIRED:
      return { ...state,
        pendingTally: action.payload.operation,
        pendingTallyMode: action.payload.mode,
        pendingSwitchWorkcenterId: action.payload.workcenterId || false
      }
    case TALLY_CANCELLED:
      return { ...state,
        pendingTally: false,
        pendingTallyMode: false,
        pendingSwitchWorkcenterId: false
      }
    case LOGOUT_USER:
      destroySession()
      return resetState
    case LOGIN_USER_ERROR:
      return { ...state,
        invalid: true
      }
    case SET_LANG:
      setLang(action.payload)
      return state
    default:
      return state
  }
}
